import React, { useEffect, useState } from "react";
import styles from "./Menu.module.scss";
import { MenuItemType, MenuType } from "../../../types/baseTypes";
import MenuItem from "./MenuItem/MenuItem";
import { useKeyboardNavigation } from "./keyboard-navigation";
import { Post } from "@aleksundshantu/aunds-deepl-unmute-types/client";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";

interface MenuProps {
  menu: MenuType;
  pageData?: Post;
}

export type MenuParentType = MenuItemType | undefined;

export const Menu = ({ menu, pageData }: MenuProps) => {
  const [currentSubmenu, setCurrentSubmenu] = useState<MenuParentType>();
  const { label } = useGlobalContext();
  const { menuRef, items, focusedItem, keyDown, controlMenu } =
    useKeyboardNavigation({
      menu,
      setCurrentSubmenu,
      type: "menu",
      subMenu: undefined,
    });

  useEffect(() => {
    const handleFocusChange = (event: FocusEvent) => {
      if (!menuRef.current?.contains(event.target as Node)) {
        setCurrentSubmenu(undefined);
      }
    };

    document.addEventListener("focusin", handleFocusChange);

    return () => {
      document.removeEventListener("focusin", handleFocusChange);
    };
  }, [menuRef]);

  return (
    <ul
      ref={menuRef}
      role="menubar"
      aria-label={label("global", "aria_label", "main_menu", "Hauptmenü")}
      className={`${styles["main-menu"]}`}
      onKeyDown={keyDown}
    >
      {menu &&
        Array.isArray(menu.items) &&
        menu.items.map((item, key) => {
          if (!items.current[key]) {
            items.current[key] = React.createRef<HTMLLIElement>();
          }
          return (
            <MenuItem
              item={item}
              key={key}
              pageData={pageData}
              currentSubmenu={currentSubmenu}
              setCurrentSubmenu={setCurrentSubmenu}
              parentSubMenu={undefined}
              subMenu={item}
              tabIndex={key === focusedItem.current ? 0 : -1}
              itemRef={items.current[key]}
              controlParentMenu={controlMenu}
            />
          );
        })}
    </ul>
  );
};
